module.exports = __webpack_public_path__ + "static/media/icon-settings-reveal-icon.214d47ab.svg";